import { AuthModel } from '../auth-model'
import { createReducer, on, Action } from '@ngrx/store'
import { user_loaded, user_unloaded, user_signed_out } from '../actions/auth-action-types'

export const INITIAL_STATE: AuthModel = {
  user: null,
  isAuthenticated: false
}

const authReducer = createReducer(
  INITIAL_STATE,
  on(user_loaded, (state, { user }) => ({ user, isAuthenticated: true })),
  on(user_unloaded, state => ({ user: null, isAuthenticated: false })),
  on(user_signed_out, state => ({ user: null, isAuthenticated: false }))
)

export const authFeatureKey = 'auth'

export function reducer(state: AuthModel, action: Action) {
  return authReducer(state, action)
}
